import { store } from "~/state/store";
import { Unsubscribe } from "redux";
import { watch, watchSubscriptions } from "~/state/util";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import { whereamis } from "~/util/providers/poiagg";
import { setSubscriptions } from "~/state/share-position/state";

async function updateWhereamis(newSubscriptions: Array<ISubscriptionWithDescription>, oldSubscriptions: Array<ISubscriptionWithDescription>) {
	try {
		// najdeme si vsechny, ktere nejsou zrusene, prosle a jsou genericke
		const newFiltered = newSubscriptions.filter(subscription => subscription.sharingStatus !== "canceled" && subscription.sharingStatus !== "expired" && subscription.sharingType !== "navigation");
		const oldFiltered = oldSubscriptions.filter(subscription => subscription.sharingStatus !== "canceled" && subscription.sharingStatus !== "expired" && subscription.sharingType !== "navigation");
		// najdeme ty, ktere jsou v novych a ne ve starych, nebo maji jine souradnice (a tedy potencialne jine whereami)
		const updateNeeded: Array<ISubscriptionWithDescription> = newFiltered.filter(subscription => {
			const index = oldFiltered.findIndex(oldSubscription => oldSubscription.subscriptionId === subscription.subscriptionId);

			if (index === -1) {
				return true;
			}

			const oldSubscription = oldFiltered[index];

			return subscription.position && (subscription.position.lon !== oldSubscription.position?.lon || subscription.position.lat !== oldSubscription.position?.lat);
		});

		if (!updateNeeded.length) {
			return;
		}

		const whereAmIResponses = await whereamis(updateNeeded.map(subscription => ({
			longitude: subscription.position?.lon || 0,
			latitude: subscription.position?.lat || 0,
			zoom: 12,
		})));

		store.dispatch(setSubscriptions(newSubscriptions.map(subscription => {
			const index = updateNeeded.findIndex(update => update.subscriptionId === subscription.subscriptionId);

			if (index !== -1) {
				return {
					...subscription,
					whereami: whereAmIResponses[index],
				};
			}

			return subscription;
		})));
	// pokud se to nepovedlo, tak proste nemame updatovane whereami
	} catch (ex) {
		// eslint-disable-next-line no-console
		console.log("SharePositionWhereami: whereami update failed", ex);
	}
}

export default class SharePositionWhereami {
	#storeUnsubscribeSubscriptions: Unsubscribe;

	constructor() {
		const state = store.getState();
		const wtSharePositionSubscriptions = watch(store.getState, "sharePosition.subscriptions", watchSubscriptions);

		this.#storeUnsubscribeSubscriptions = store.subscribe(wtSharePositionSubscriptions((newSubscriptions, oldSubscriptions) => {
			updateWhereamis(newSubscriptions, oldSubscriptions);
		}));
		updateWhereamis(state.sharePosition.subscriptions, []);
	}

	destroy() {
		this.#storeUnsubscribeSubscriptions();
	}
}
